import { useRef } from 'react';
import { apiUrl, wsUrl } from 'config/settings';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeMcCommand,
  changeModeActive,
  setFault,
  setIsConnectedMc,
  setSensor,
  setB22Sensor,
} from 'store/mcSlice';
import { v4 as uuidv4 } from 'uuid';
import { setShowMassage, setWsIsConnected } from 'store/sysSlice';
import store from "store"
import { editServicesCall, removeServicesCall } from 'store/servicesCallSlice';
import { setClient } from 'store/clientsSlice';
import { setNotifications } from 'store/notificationSlice';
import { sortArray } from 'config/functions';
import http from '../http'

const useWebSocket = () => {
  const socket = useRef(null);
  const dispatch = useDispatch();
  const isConnected = useSelector((state) => state.sys?.wsIsConnected);
  let ws = null
  let reconnectedTimer = null

  const DATA_TYPE = {
    SENSOR: 's',
    STATUS: 'status',
    FAULT: 'fault',
    NEW_CLIENT: "newClient"
  }

  const getNotifications = async () => {
    try {
      const res = await http.get(`${apiUrl}/notification`)
      dispatch(setNotifications(sortArray(res?.data?.data, "created", true)))
    } catch (error) {
      dispatch(setShowMassage({ massage: "GET_NOTIFICATION_ERROR", type: "error" }))
    }
  }

  const connected = (bizPath) => {
    if (isConnected)
      return

    ws = new WebSocket(`${wsUrl}?bizId=${bizPath}-${uuidv4()}`);
    socket.current = ws;

    ws.onopen = () => {
      dispatch(setWsIsConnected(true))
      console.log('connected')
      if (reconnectedTimer)
        reconnected("off")
    }

    ws.onclose = () => {
      console.log('disConnected')
      dispatch(setWsIsConnected(false))
      disconnected()
      reconnected("on")
    }

    ws.onmessage = (event) => {
      const dataType = event?.data?.split('/')[0]
      const data = event?.data?.split('/')[2]

      /** global */
      if (dataType === DATA_TYPE.NEW_CLIENT) {
        dispatch(setClient(data))
      }

      /** MC */
      else if (dataType === DATA_TYPE.SENSOR) {
        dispatch(setSensor(event?.data))
      }
      else if (dataType === 'b22') {
        try {
          const update = JSON.parse(event.data.split('/').slice(2).join('/'))
          dispatch(setB22Sensor(update))
          if (update.notificationCreated || update.notificationRemoved) getNotifications()
        } catch (error) {
          console.error('Invalid B2.2 update', error)
        }
      }
      else if (dataType === DATA_TYPE.FAULT) {
        const value = event?.data.split('/')
        dispatch(setFault(event?.data))
        if (value[3] !== "none") getNotifications()
      }
      else if (dataType === 'callBackCommand') {
        dispatch(changeMcCommand(JSON.parse(data)))
      }
      else if (dataType === 'modeActive') {
        dispatch(changeModeActive(event?.data))
      }

      else if (dataType === 'mcConnected' || dataType === 'mcDisConnected') {
        const item = { isConnected: dataType === 'mcConnected' ? true : false, guid: data }
        dispatch(setIsConnectedMc(item))
      }

      /** Services Call */
      else if (dataType === 'newServicesCall') {
        dispatch(editServicesCall(event?.data))
      }
      else if (dataType === 'editServicesCall') {
        dispatch(editServicesCall(event?.data))
      }
      else if (dataType === 'removeServicesCall') {
        dispatch(removeServicesCall(event?.data))
      }
    };
  }

  const disconnected = () => {
    if (socket) {
      ws = null
      socket.current = null;
    }
  }

  const reconnected = (type) => {
    if (type === "off") {
      clearInterval(reconnectedTimer)
      reconnectedTimer = null
    }
    else if ("on" && !reconnectedTimer) {
      const stateList = store.getState();
      const path = stateList?.biz?.data?.path

      reconnectedTimer = setInterval(() => {
        if (!isConnected)
          connected(path)
      }, 15000);
    }
  }

  const sendMessage = (msg) => {
    if (isConnected) {
      socket.current.send(msg);
    }
  };

  return { connected, disconnected, sendMessage }
};

export default useWebSocket;
